/* eslint-disable @next/next/no-img-element */

import BlogBlockStyle from '../../styles/blog/BlogBlockStyle.module.scss';
import { urlFor } from '../../lib/sanity';
import Link from 'next/link';
import Date from '../../components/blog/date'




const BlogBlock = ({ Posts }) => {



  return (
    <>
      <ul className={BlogBlockStyle.blogList}>
        {Posts?.length > 0 &&
          Posts.map((post) => (
            <li key={post._id} className={BlogBlockStyle.copyColor}>
              <div className={BlogBlockStyle.imgHolder}>
                <img src={urlFor(post.coverImage).auto('format').width(650).height(350).url()} alt={post?.alt} width="650" height="350" loading="lazy" className={BlogBlockStyle.blogImage} />
              </div>

              <div className={BlogBlockStyle.copyBlock}>
                <div className={BlogBlockStyle.dateHolder}>{post.date && <Date dateString={post?.date} />}</div>
                <h3>{post.title}</h3>

                <p>{post.excerpt}</p>
                <Link href={`/blog/${post.slug.current}`}>
                  <button className={BlogBlockStyle.button}>Read More</button>
                </Link>
              </div>
            </li>
          ))}
      </ul>
    </>
  );
};

export default BlogBlock;
